module.exports = __webpack_public_path__ + "img/no_image_available.0a66eecb.jpg";